import Vue from "vue";
import store from "./store";
// import {isMobile} from "mobile-device-detect";
import Router from "vue-router";
import NProgress from "nprogress";
import authenticate from "./middleware/auth";
import guest from "./middleware/guest";

Vue.use(Router);

// create new router

// const Settings = () => import("./views/app/pages/settings/index").then((m) => m.default || m);
// const SettingsProfile = () => import("./views/app/pages/settings/profile").then((m) => m.default || m);
// const SettingsPassword = () => import("./views/app/pages/settings/password").then((m) => m.default || m);
// const SettingsReseller = () => import("./views/app/pages/settings/reseller").then((m) => m.default || m);
// const SettingsSocial = () => import("./views/app/pages/settings/social").then((m) => m.default || m);

const routes = [
  // {
  //   path: "*",
  //   redirect: '/maintain'
  // },
  // {
  //   path: "/",
  //   component: () => import("./views/app/pages/maintain"),
  //   children:[
  //     {
  //       path: 'maintain',
  //       name: 'maintain',
  //       component: () => import("./views/app/pages/maintain")
  //     }
  //   ]
  // },
  {
    path: "/app",
    component: () => import("./views/app"), //webpackChunkName app
    // beforeEnter: authenticate,
    redirect: "/app/news",

    children: [
      // pages
      {
        path: "/",
        component: () => import("./views/app/pages"),
        beforeEnter: authenticate,
        //redirect: "/app/pages/profile",

        children: [
          {
            path: "/:id/:slide/step2/",
            name: "step2",
            component: () => import("./views/app/pages/builder"),
          },
          {
            path: "home",
            component: () => import("./views/app/pages/homeIndex"),
          },

          {
            path: "error",
            component: () => import("./views/app/pages/notFound"),
          },
          {
            path: "faq",
            component: () => import("./views/app/pages/faq"),
          },
          {
            path: "blank",
            component: () => import("./views/app/pages/blank"),
          },
          {
            path: "news",
            name: "news",
            component: () => import("./views/app/pages/homeIndex"),
          },
          {
            path: "job-finder",
            name: "Job Finder",
            component: () => import("./views/app/pages/job-finder"),
          },
          {
            path: "deluxe",
            name: "Deluxe",
            component: () => import("./views/app/pages/deluxe"),
          },
          {
            path: "videos-scripts",
            name: "Video scripts",
            component: () => import("./views/app/pages/videos-scripts"),
          },
          {
            path: "vidtoon",
            name: "VidToon App",
            component: () => import("./views/app/pages/vidtoon"),
          },
          {
            path: "subusers/:bid",
            name: "subusers",
            component: () => import("./views/app/pages/subusers"),
          },
          {
            path: "new-project",
            name: "new-project",
            component: () => import("./views/app/pages/new-project"),
          },
          {
            path: "your-projects",
            name: "your-projects",
            component: () => import("./views/app/pages/your-project"),
          },
          {
            path: "training",
            name: "training",
            component: () => import("./views/app/pages/training"),
          },
          {
            path: "my_purchases",
            name: "my_purchases",
            component: () => import("./views/app/pages/my_purchases"),
          },
          {
            path: "brands",
            name: "Brands",
            component: () => import("./views/app/pages/brands"),
          },
          {
            path: "support",
            name: "support",
            component: () => import("./views/app/pages/support"),
          },
          {
            path: "new-template",
            name: "new-template",
            component: () => import("./views/app/pages/NewTemplate"),
          },

          {
            path: "new",
            name: "new",
            component: () => import("./views/app/pages/NewPrez"),
          },
          {
            path: "feeds",
            name: "feeds",
            component: () => import("./views/app/pages/feeds"),
          },
          {
            path: "newYT",
            name: "newYT",
            component: () => import("./views/app/pages/NewPrezYT"),
          },
          {
            path: "NewTpl/:id",
            name: "NewTpl",
            component: () => import("./views/app/pages/NewPrezTpl"),
          },
          {
            path: "settings",
            name: "settings",
            component: () => import("./views/app/pages/settings"),
            children: [
              {
                path: "social",
                name: "settings.social",
                component: () => import("./views/app/pages/settings/social"),
              },
              {
                path: "profile",
                name: "settings.profile",
                component: () => import("./views/app/pages/settings/profile"),
              },
              {
                path: "password",
                name: "settings.password",
                component: () => import("./views/app/pages/settings/password"),
              },
              {
                path: "usergraphic",
                name: "settings.usergraphic",
                component: () => import("./views/app/pages/settings/usergraphic"),
              },
              {
                path: "usersound",
                name: "settings.usersound",
                component: () => import("./views/app/pages/settings/usersound"),
              },
              {
                path: "reseller",
                name: "settings.reseller",
                component: () => import("./views/app/pages/settings/reseller"),
              },
              { path: "", redirect: { name: "settings.profile" } },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "/login",
    // beforeEnter: guest,
    name: "login",
    component: () => import("./views/app/sessions/signIn"),
  },

  // sessions
  {
    path: "/login/b/:b?",
    // beforeEnter: guest,
    name: "loginb",
    component: () => import("./views/app/sessions/signIn"),
  },

  {
    path: "/login/forgot/b/:b",
    beforeEnter: guest,
    component: () => import("./views/app/sessions/forgot"),
  },

  {
    path: "/login/forgot",
    beforeEnter: guest,
    component: () => import("./views/app/sessions/forgot"),
  },

  {
    path: "/",
    beforeEnter: (to, from, next) => {
      window.location = `${process.env.MIX_APP_URL}/app/news`
    }
  },

  {
    path: "/password/reset/:token",
    beforeEnter: guest,
    component: () => import("./views/app/sessions/reset"),
  },

  {
    path: "*",
    component: () => import("./views/app/pages/notFound"),
  },
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.path) {
    // Start the route progress bar.

    NProgress.start();
    NProgress.set(0.1);
  }
  next();
});

router.afterEach(() => {
  // Remove initial loading
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  // Complete the animation of the route progress bar.
  setTimeout(() => NProgress.done(), 500);
  // NProgress.done();
  // if (isMobile) {
  if (window.innerWidth <= 1200) {
    // console.log("mobile");
    store.dispatch("changeSidebarProperties");
    if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
      store.dispatch("changeSecondarySidebarProperties");
    }

    // if (store.getters.getCompactSideBarToggleProperties.isSideNavOpen) {
    //   store.dispatch("changeCompactSidebarProperties");
    // }
  } else {
    if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
      store.dispatch("changeSecondarySidebarProperties");
    }

    // store.state.sidebarToggleProperties.isSecondarySideNavOpen = false;
  }
});

export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/router.js